import React, { ReactNode } from 'react';
import Icon from 'flow/components/ui-components/Icon';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    children: ReactNode;
    headerTitle: string;
    handleNavigate?: () => void;
    setModalButton?: React.JSX.Element;
}

const ContactBox = ({
    children,
    headerTitle,
    handleNavigate,
    setModalButton,
}: Props) => {
    const { i18next } = useAppContext();
    return (
        <div className="shadow-soft dark:shadow-base w-full flex-1 rounded-sm bg-white p-1 dark:border-none dark:bg-gray-100">
            <header className="flex items-center justify-between py-5 ps-6 pe-4">
                <div className="text-2xl/5 font-bold text-gray-800">
                    {headerTitle}
                </div>

                {handleNavigate && (
                    <button
                        aria-label={i18next.t('action.open')}
                        className="group rounded-sm p-1 hover:bg-gray-100"
                        onClick={handleNavigate}
                    >
                        <Icon
                            className="text-gray-500 group-hover:text-gray-500 rtl:scale-x-[-1]"
                            iconKey="arrow_forward"
                        />
                    </button>
                )}
                {setModalButton}
            </header>
            {children}
        </div>
    );
};

export default React.memo(ContactBox);
